
import {initWebComponent} from "@/helpers/web-component-helper";
import {bytesToSize, getFileIconByExtension, getFileIndexByFormID, setFileIndexByFormID} from "@/helpers/file-helper";
import {
    getAttributeItemByFeatureInfo,
    getFeatureInfoByFeatureInfoKey
} from "@/helpers/plugin-helper";
import {showImageModal} from "@/components/layout/image-model-component";
import moment from "moment";
moment.locale('nl')

export class LayerInfoInfoPluginFileComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');
        const featureInfoKey = this.getAttribute('data-feature-info-key')
        const featureKey = this.getAttribute('data-feature-key')

        const featureInfo = getFeatureInfoByFeatureInfoKey(featureKey, featureInfoKey)
        const attributeItem = getAttributeItemByFeatureInfo(featureInfo)

        const domainID = featureInfo.DomainID
        const presentationID = featureInfo.PresentationID
        const formAttributeID = attributeItem.FormAttributeID


        let innerHTML = ``
        attributeItem.DomainList.DomainListItems.map( (domainListItem, key) => {

            console.log(featureInfo)

            setFileIndexByFormID(featureInfo.featureInfo.FormID)

            const fileIndex = getFileIndexByFormID(featureInfo.featureInfo.FormID)


            const imgSrc = window.kaartViewerUrl +  `/admin/v2/kaartviewerapi/bookmark/` + window.websiteID + `/domain/` + domainID + `/presentation/` + presentationID + `/formattribute/` + formAttributeID  + `/item/` + fileIndex + `/filename/` + domainListItem.Name + `?_=` + new Date().getTime()

            window.fileIndex++

            innerHTML += `
      <div class="row no-gutters">
        <div class="col-12">
              <div class="ui-bordered p-2">`

            const extension = domainListItem.Name.split('.')[1];
            let fileIconExtension
            if (extension !== undefined && extension !== null) {
                fileIconExtension = getFileIconByExtension(extension);
            }

            if(fileIconExtension.isImage) {
                innerHTML += `  
                  <img 
                        title="Klik om te vergroten" 
                        src="${imgSrc}"
                        data-src="${imgSrc}"
                        class="cursor-pointer pb-2" 
                        width="100%"
                    >`
            }

            innerHTML += `
                    <div class="media-body">
                        <a href="${imgSrc}" target="_blank" class="project-attachment-filename" title="${domainListItem.Name}">
                            <i class="fa ${fileIconExtension.icon}"></i>  ${domainListItem.Name}
                       </a>
                        <div class="small pt-1">
                            <i class="fa fa-file-alt"></i> ` + bytesToSize(domainListItem.Size) + ` <i class="fa fa-calendar-alt ml-1"></i> ${moment.unix(domainListItem.Timestamp).format('DD MMM YYYY HH:mm')}
                        </div>
                        <div class="pt-1">
                            <a href="${imgSrc}" target="_blank" title="Download" class="btn btn-xs btn-warning icon-btn">
                                <i class="fa fa-download"></i>
                            </a>`

            if(fileIconExtension.isImage) {
                innerHTML += `<button data-src="${imgSrc}" title="Vergroten" class="cursor-pointer btn btn-xs btn-warning icon-btn ml-1">
                                <i data-src="${imgSrc}" class="fa fa-expand-arrows-alt"></i>
                            </button>`
            }

            innerHTML += `    
                        </div>
                    </div>
                </div>
            </div>
        </div>
          
                `;
        })

        template.innerHTML = innerHTML

        initWebComponent(this, template)

        this.querySelectorAll('.cursor-pointer').forEach(element => {
            element.addEventListener('click', (e) => {
                // console.log(e.target)
                showImageModal(e.target.dataset.src)
            })
        })
    }
}

